// extracted by mini-css-extract-plugin
module.exports = {"empty":"home_empty__8Rrol","homeScreen":"home_homeScreen__2XNDg","homeMobile":"home_homeMobile__2Os90"};